// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 100%;
}

tr.example-detail-row {
  height: 0;
}

tr.example-element-row:not(.example-expanded-row):hover {
  background: whitesmoke;
}

tr.example-element-row:not(.example-expanded-row):active {
  background: #efefef;
}

.example-element-row td {
  border-bottom-width: 0;
}

.example-element-detail {
  overflow: hidden;
  display: flex;
}

.example-element-diagram {
  min-width: 80px;
  border: 2px solid black;
  padding: 8px;
  font-weight: lighter;
  margin: 8px 0;
  height: 104px;
}

.example-element-symbol {
  font-weight: bold;
  font-size: 40px;
  line-height: normal;
}

.example-element-description {
  padding: 16px;
}

.example-element-description-attribution {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./projects/eCash/src/app/administration/request-line-types/request-line-types.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEE;EACE,SAAA;AACJ;;AAEE;EACE,sBAAA;AACJ;;AAEE;EACE,mBAAA;AACJ;;AAEE;EACE,sBAAA;AACJ;;AAEE;EACE,gBAAA;EACA,aAAA;AACJ;;AAEE;EACE,eAAA;EACA,uBAAA;EACA,YAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;AACJ;;AAEE;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;AACJ;;AAEE;EACE,aAAA;AACJ;;AAEE;EACE,YAAA;AACJ","sourcesContent":["table {\n    width: 100%;\n  }\n  \n  tr.example-detail-row {\n    height: 0;\n  }\n  \n  tr.example-element-row:not(.example-expanded-row):hover {\n    background: whitesmoke;\n  }\n  \n  tr.example-element-row:not(.example-expanded-row):active {\n    background: #efefef;\n  }\n  \n  .example-element-row td {\n    border-bottom-width: 0;\n  }\n  \n  .example-element-detail {\n    overflow: hidden;\n    display: flex;\n  }\n  \n  .example-element-diagram {\n    min-width: 80px;\n    border: 2px solid black;\n    padding: 8px;\n    font-weight: lighter;\n    margin: 8px 0;\n    height: 104px;\n  }\n  \n  .example-element-symbol {\n    font-weight: bold;\n    font-size: 40px;\n    line-height: normal;\n  }\n  \n  .example-element-description {\n    padding: 16px;\n  }\n  \n  .example-element-description-attribution {\n    opacity: 0.5;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
